/**
 * Submit Your Ride ("Submit Your Build") — HubSpot Forms API v3 submission.
 *
 * This form previously had no working destination (empty action, no submit
 * handler), so this makes it functional: on submit we POST the text fields to
 * HubSpot. The "Upload Your Pictures" file field is intentionally NOT sent —
 * HubSpot's Forms API can't accept file uploads (client's call); photos come in
 * via the cloud-link field (`dropbox`). Per-submission email delivery (e.g. to
 * jcomeskey@forgeline.com) is configured in HubSpot's form notification settings.
 *
 * Public endpoint (keyed on portalId+formId) — no secret. Mirrors gtu-contact-page.js.
 */
(function () {
  'use strict';

  var PORTAL_ID = '50831863';
  var FORM_ID = 'ea3632e8-9d39-4758-ac00-b39335d754e7';

  // Theme field name -> HubSpot property name. vehicle_owner + images handled separately.
  var FIELD_MAP = {
    email: 'email',
    make: 'car_make',
    model: 'car_model',
    year: 'car_year',
    trim: 'car_trim',
    description: 'message',
    wheel_purchase_source: 'how_did_you_purchase_your_wheels',
    instagram: 'instagram',
    facebook: 'facebook',
    youtube: 'youtube',
    cloud_link: 'dropbox',
  };

  function getCookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : '';
  }

  function val(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el && el.value ? el.value.trim() : '';
  }

  function buildPayload(form) {
    var fields = [];

    // Owner -> firstname + lastname (split on the first space; client approved).
    var owner = val(form, 'vehicle_owner');
    if (owner) {
      var sp = owner.indexOf(' ');
      fields.push({ objectTypeId: '0-1', name: 'firstname', value: sp === -1 ? owner : owner.slice(0, sp) });
      var last = sp === -1 ? '' : owner.slice(sp + 1).trim();
      if (last) fields.push({ objectTypeId: '0-1', name: 'lastname', value: last });
    }

    Object.keys(FIELD_MAP).forEach(function (name) {
      var v = val(form, name);
      if (v) fields.push({ objectTypeId: '0-1', name: FIELD_MAP[name], value: v });
    });

    // Marketing opt-in — sent as a field (the subscriptionTypeId for "Marketing
    // Information" on this portal is TBD; mirrors the contact form's approach).
    var optin = form.querySelector('[name="marketing_optin"]');
    if (optin && optin.checked) {
      fields.push({ objectTypeId: '0-1', name: 'email_opt_in', value: 'true' });
    }

    var context = { pageUri: window.location.href, pageName: document.title };
    var hutk = getCookie('hubspotutk');
    if (hutk) context.hutk = hutk;

    return { fields: fields, context: context };
  }

  function showStatus(form, ok, msg) {
    var box = form.querySelector('#sb-form-status');
    if (!box) return;
    box.hidden = false;
    box.className = 'sb-form__status ' + (ok ? 'sb-form__status--success' : 'sb-form__status--error');
    box.textContent = msg;
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function setSubmitting(form, on) {
    var btn = form.querySelector('.sb-form__submit');
    if (!btn) return;
    if (on) {
      btn.dataset.label = btn.textContent;
      btn.textContent = 'SENDING…';
      btn.disabled = true;
    } else {
      if (btn.dataset.label) btn.textContent = btn.dataset.label;
      btn.disabled = false;
    }
  }

  function init() {
    var form = document.getElementById('submit-build-form');
    if (!form) return;

    form.addEventListener('submit', async function (e) {
      e.preventDefault(); // form has no working native destination
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      setSubmitting(form, true);
      try {
        var url = 'https://api.hsforms.com/submissions/v3/integration/submit/' + PORTAL_ID + '/' + FORM_ID;
        var res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(buildPayload(form)),
        });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        showStatus(form, true, 'Thanks! Your build has been submitted — we’ll be in touch.');
        form.reset();
      } catch (err) {
        showStatus(form, false, 'Sorry, something went wrong submitting your build. Please try again.');
        if (window.console) console.error('[submit-build] HubSpot submission error:', err);
      } finally {
        setSubmitting(form, false);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
